import React, { useState } from "react";
import PropTypes from "prop-types";

import GroupCheckinAlert from './GroupCheckinAlert';
import SubmitButton from './SubmitButton';

const Actions = ({ uuid, redeemState, orderAmount, orderItems, allowCheckout, onClick }) => {
  const [checkInAll, setCheckInAll] = useState(false);

  const showGroupCheckinAlert = redeemState === "initiated" && orderAmount > 1;

  return (
    <div style={{width: '100%', display: 'flex', flexDirection: 'column', gap: '8px'}}>

      {showGroupCheckinAlert && (
        <GroupCheckinAlert
          scannedUuid={uuid}
          orderItems={orderItems}
          checkInAll={checkInAll}
          onCheckInAllChange={setCheckInAll}
        />
      )}
      
      <SubmitButton
        uuid={uuid}
        redeemState={redeemState}
        orderAmount={orderAmount}
        checkInAll={checkInAll}
        allowCheckout={allowCheckout}
        onClick={onClick}
      />
      
    </div>
  );
};

Actions.propTypes = {
  uuid: PropTypes.string,
  redeemState: PropTypes.string,
  orderAmount: PropTypes.number,
  orderItems: PropTypes.array,
  allowCheckout: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Actions;